import React, {PureComponent} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card'
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import editIcon from "../../../assets/edit-white.png";
import trashIcon from "../../../assets/trash.png";
import Connect from "react-redux/es/connect/connect";
import {withTranslation} from "react-i18next";
import {
	changeKeyValueInLayout,
	dispatchOnPresentationHeaderChanged,
	dispatchOnPresentationLayoutChanged,
	dispatchOnPresentationSectionEditingChanged,
	dispatchOnPresentationSectionSelectedChanged,
	dispatchOnPresentationSelectingPropChanged,
	getContentArrayKey,
	getContentKey,
	getcontentStyle,
	getListStyle,
	removeContentFromLayout,
	reorderLayout
} from "../functions";
import {debug} from "../../../utility/functions";

let timer;

export const onSectionSelected = (name, index, open = null) => {
	let accordionHeader = document.getElementById("accordionHeader" + name + index);

	if (open !== null) {
		if (open && !accordionHeader.classList.contains('open')) {
			openMenu(name, index, open)
		} else if (!open && accordionHeader.classList.contains('open')) {
			closeMenu(name, index)
		}
	} else {
		if (accordionHeader.classList.contains('open')) {
			closeMenu(name, index)
		} else {
			openMenu(name, index)
		}
	}
};

const openMenu = (name, index, click = false) => {
	let accordionHeader = document.getElementById("accordionHeader" + name + index);
	let arrow = document.getElementById("dropdownArrow" + name + index);

	if (click) {
		accordionHeader.click();
	}
	accordionHeader.classList.add("open");
	arrow.classList.remove('down');
	arrow.classList.add('up');
};

const closeMenu = (name, index) => {
	let accordionHeader = document.getElementById("accordionHeader" + name + index);
	let arrow = document.getElementById("dropdownArrow" + name + index);

	accordionHeader.classList.remove("open");
	arrow.classList.remove('up');
	arrow.classList.add('down');
};

class LayoutComponent extends PureComponent {

	onDragEnd = (result, index) => {
		const {newLayout} = this.props;
		if (!result || !newLayout) return null;
		const layout = reorderLayout(newLayout, result, index);
		if (layout) this.props.dispatchOnPresentationLayoutChanged(layout);
	};

	onRemoveContentPressed = (e, i, index) => {
		debug(e, i, index)
		const {newLayout} = this.props;
		if (!newLayout) return null;
		const layout = removeContentFromLayout(newLayout, i, index);
		if (layout) this.props.dispatchOnPresentationLayoutChanged(layout);
	};

	setEditSection = (value) => {
		this.props.dispatchOnPresentationSectionEditingChanged(value);
	};

	onEditSectionPressed = (e, index) => {
		const {sectionEditing} = this.props;
		const key = getContentKey(index);
		if (sectionEditing === key) {
			this.setEditSection(null);
		} else {
			this.setEditSection(key);
		}
		e.stopPropagation();
	};

	onAddContentPressed = (e, name, index) => {
		debug("e", e, "name", name, "index", index);
		this.props.dispatchOnPresentationHeaderChanged(name, index);
		this.props.dispatchOnPresentationSelectingPropChanged(true, getContentArrayKey(index));
		e.stopPropagation();
	};

	onSectionNameChanged = ({key, value}) => {
		const {newLayout} = this.props;
		if (!newLayout) return null;
		const layout = changeKeyValueInLayout(newLayout, key, value);
		if (layout) this.props.dispatchOnPresentationLayoutChanged(layout);
	};

	renderSectionName(index) {
		const {sectionEditing, newLayout} = this.props;
		let name;
		const key = getContentKey(index);

		if (newLayout[key]) name = newLayout[key]

		if (sectionEditing === key) {
			return (
				<input
					ref={ref => this.input = ref}
					onClick={(e) => {
						e.stopPropagation()
					}}
					type={"text"}
					value={name}
					name={key}
					onBlur={() => {
						this.setEditSection(null);
					}}
					onChange={(e) => {
						this.onSectionNameChanged({key: e.target.name, value: e.target.value})
					}}
				/>
			);
		} else {
			return name;
		}
	};

	renderLayoutContent(contentDataArray, i) {
		if (contentDataArray.length > 0) {
			return contentDataArray.map((content, index) => {
				const key = "article_" + content.id + "_parent_" + i + "_child_" + index;
				return (
					<Draggable
						key={key}
						draggableId={key}
						index={index}
					>
						{(provided, snapshot) => (
							<div>
								<Accordion.Collapse eventKey={i}>
									<li className="column" ref={provided.innerRef}
									    {...provided.dragHandleProps}
									    {...provided.draggableProps}
									    style={getcontentStyle(
										    provided.draggableProps.style,
										    snapshot.isDragging
									    )}>
										<Card.Body className="striped-white div-presentation-table-row-container">
											<div className={'div-presentation-table-value'}>{content.title ? content.title : content.name ? content.name : ""}</div>
											<img
												width={15}
												height={15}
												style={{marginLeft: 20, float: 'right'}}
												alt="edit class"
												src={trashIcon}
												className="classes-list-content-action-icon"
												onClick={(e) => {
													this.onRemoveContentPressed(e, i, index)
												}}
											/>
										</Card.Body>
										{provided.placeholder}
									</li>
								</Accordion.Collapse>
							</div>
						)}
					</Draggable>
				)
			})
		} else {
			return (
				<div>Não existem artigos nesta secção</div>
			)
		}
	}

	renderLayout() {
		const {newLayout} = this.props;

		if (!newLayout) return null;

		const contentArray = Object.keys(newLayout)
			.filter((key) => key.includes('content') && !key.includes('array'))
			.map((key) => {
				return newLayout[key]
			});

		const contentDataArray = Object.keys(newLayout)
			.filter((key) => key.includes('content') && key.includes('array'))
			.map((key) => {
				return newLayout[key]
			});

		return contentArray.map((name, index) => {
			return (
				<Accordion
					key={index}
					className="accordion"
					defaultActiveKey="0"
				>
					<Card id={'card-' + name + "-" + index}>
						<Accordion.Toggle
							ref={ref => this['accordionHeader' + name + index] = ref}
							key={index}
							id={'accordionHeader' + name + index}
							eventKey={index}
							as={Card.Header}
							onClick={(e) => onSectionSelected(name, index)}
						>
							<div
								id={index} className="classes-list-content-action"
								onClick={() => {
								}}
							>
								<img
									alt="edit class"
									src={editIcon}
									className="classes-list-content-action-icon"
									onClick={(e) => {
										this.onEditSectionPressed(e, index)
									}}
								/>
								{this.renderSectionName(index)}
								<span
									className="presentation-content-action-button">
									<i
										className="arrow down"
										id={"dropdownArrow" + name + index}
									/>
								</span>
								<button className="btn btn-success presentation-content-action-button"
								        onClick={(e) => {
									        this.onAddContentPressed(e, name, index)
								        }}>
									+
								</button>
							</div>
						</Accordion.Toggle>
						<DragDropContext
							onDragEnd={(result) => {
								this.onDragEnd(result, index);
							}}
						>
							<Droppable droppableId={"droppable" + name + index}>
								{(provided, snapshot) => (
									<div
										ref={provided.innerRef}
										style={getListStyle(snapshot.isDraggingOver)}
										{...provided.droppableProps}
									>
										<ul className="columns">
											{this.renderLayoutContent(contentDataArray[index], index)}
											{provided.placeholder}
										</ul>
									</div>
								)}
							</Droppable>
						</DragDropContext>
					</Card>
				</Accordion>
			);
		})
	}

	render() {
		return (
			<div>
				{this.renderLayout()}
			</div>
		)
	}
}

const mapStateToProps = store => ({
	layout: store.presentationReducer.layout,
	index: store.presentationReducer.index,
	sectionEditing: store.presentationReducer.sectionEditing,
	newLayout: store.presentationReducer.newLayout,
});

const mapFunctionsToProps = {
	dispatchOnPresentationLayoutChanged,
	dispatchOnPresentationSelectingPropChanged,
	dispatchOnPresentationSectionEditingChanged,
	dispatchOnPresentationSectionSelectedChanged,
	dispatchOnPresentationHeaderChanged
};

export default Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(LayoutComponent));